export default __webpack_public_path__ + "static/media/avatar5.ffd2f0d1.png";